/* ==========================================================================
   blog.js — client-side search + category filter for the blog index.
   ========================================================================== */
(function () {
  "use strict";

  var grid = document.querySelector("[data-blog-grid]");
  if (!grid) return;

  var cards = Array.prototype.slice.call(grid.querySelectorAll("[data-blog-item]"));
  var searchInput = document.querySelector("[data-blog-search]");
  var catButtons = document.querySelectorAll("[data-blog-cat]");
  var emptyState = document.querySelector("[data-blog-empty]");
  var activeCategory = "all";

  function apply() {
    var term = (searchInput && searchInput.value || "").toLowerCase().trim();
    var visible = 0;
    cards.forEach(function (card) {
      var title = (card.getAttribute("data-title") || "").toLowerCase();
      var category = card.getAttribute("data-category");
      var matchesTerm = !term || title.indexOf(term) !== -1;
      var matchesCat = activeCategory === "all" || category === activeCategory;
      var show = matchesTerm && matchesCat;
      card.style.display = show ? "" : "none";
      if (show) visible++;
    });
    if (emptyState) emptyState.style.display = visible === 0 ? "flex" : "none";
  }

  if (searchInput) searchInput.addEventListener("input", apply);
  catButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      activeCategory = btn.getAttribute("data-blog-cat");
      catButtons.forEach(function (b) { b.classList.toggle("is-active", b === btn); });
      apply();
    });
  });
})();
